export type ZoomArea = 'Background' | 'Full Body' | 'Lower Body' | 'Mid Body' | 'Upper Body'

export type Category1 = 'Accessory' | 'Body' | 'Clothing' | 'Location' | 'Pose'

export type Category2 =
  | 'Animal'
  | 'Bottoms'
  | 'Bows/Ties'
  | 'Chibi Poses'
  | 'Companions'
  | 'Cooking'
  | 'District'
  | 'Dress-Ups'
  | 'Dresses'
  | 'Expression'
  | 'Eyes'
  | 'Eyewear'
  | 'Facial Hair'
  | 'Hair'
  | 'Headwear'
  | 'Holdables'
  | 'Jewellery'
  | 'Jumpsuits'
  | 'Mobility'
  | 'Outerwear'
  | 'School Uniform'
  | 'Set'
  | 'Shoes'
  | 'Signs'
  | 'Skin'
  | 'Sports Equipment'
  | 'Stick Figure Poses'
  | 'Time'
  | 'Tools'
  | 'Tops'

export type Category3 =
  | 'Bag'
  | 'Beanie'
  | 'Cape'
  | 'Cardigen'
  | 'Characteristics'
  | 'Coat'
  | 'Colour'
  | 'Devices'
  | 'Dress Shirt'
  | 'Drinks'
  | 'Earrings'
  | 'Food'
  | 'Gaming'
  | 'Gifts'
  | 'Glasses'
  | 'Hair Accessory'
  | 'Hat'
  | 'Headband'
  | 'Hobby'
  | 'Hoodie'
  | 'Jacket'
  | 'Lashes'
  | 'Long Sleeve'
  | 'Necklace'
  | 'Other'
  | 'Pants'
  | 'Patch'
  | 'Piercings'
  | 'Scarfs'
  | 'Set'
  | 'Shirt'
  | 'Shorts'
  | 'Skirt'
  | 'Style'
  | 'Suit'
  | 'Tank Top'
  | 'Tiara/Crowns'
  | 'Tone'
  | 'Tools'
  | 'Tops'
  | 'Umbrella'
  | 'Uniform'
  | 'Vest'

export type Stage = 'Final' | 'In Quality Control' | 'Bug' | 'Art Updates'

export interface TraitData {
  id: number
  name: string
  stage: Stage
  category1: Category1
  category2: Category2
  category3?: Category3
  zoomArea?: ZoomArea
  searchableTags: string[]
  devTags: string[]
  frontIndex?: number
  backIndex?: number
  basicFrontFile?: string
  armBehindBackFrontFile?: string
  chibiBasicFrontFile?: string
  waveFrontFile?: string
  hipFrontFile?: string
  peaceFrontFile?: string
  holdingFrontFile?: string
  basicBackFile?: string
  armBehindBackBackFile?: string
  chibiBasicBackFile?: string
  waveBackFile?: string
  hipBackFile?: string
  peaceBackFile?: string
  holdingBackFile?: string
}

const traitsData: TraitData[] = [
  {
    id: 213,
    name: 'Bats',
    stage: 'Art Updates',
    category1: 'Accessory',
    category2: 'Animal',
    searchableTags: ['Halloween', 'Animal', 'Bat', 'Witch', 'Seasonal', 'Background', 'Black'],
    devTags: [],
    frontIndex: 20000,
  },
  {
    id: 328,
    name: 'Dark Blue Tie',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Bows/Ties',
    searchableTags: [],
    devTags: [],
    frontIndex: 6000,
    basicFrontFile: 'Dark Blue Tie.svg',
  },
  {
    id: 147,
    name: 'Loose Orange Tie',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Bows/Ties',
    searchableTags: [],
    devTags: [],
    frontIndex: 6000,
    basicFrontFile: 'Loose Orange Tie.svg',
  },
  {
    id: 98,
    name: 'Seasonal Large Red Bowtie',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Bows/Ties',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Seasonal Large Red Bowtie.svg',
  },
  {
    id: 394,
    name: 'Cookie Cat Plushie',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Companions',
    searchableTags: ['Hold', 'Black', 'Location', 'Animal'],
    devTags: ['Hold'],
    frontIndex: 1000,
    basicFrontFile: 'Cookie Plushie.svg',
    holdingFrontFile: 'Cookie Plushie.svg',
  },
  {
    id: 171,
    name: 'Exclusive CC Astro',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Companions',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Exclusive CC Astro.svg',
  },
  {
    id: 128,
    name: 'Exclusive CS Plushie',
    stage: 'In Quality Control',
    category1: 'Accessory',
    category2: 'Companions',
    searchableTags: ['Hold'],
    devTags: ['Hold'],
    frontIndex: 1000,
    basicFrontFile: 'Exclusive CS Plushie.svg',
    holdingFrontFile: 'Exclusive CS Plushie.svg',
  },
  {
    id: 218,
    name: 'Exclusive RR Tako',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Companions',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Exclusive RR Tako.svg',
  },
  {
    id: 393,
    name: 'Oreo Cat Plushie',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Companions',
    searchableTags: ['Hold', 'Black', 'Location', 'Animal'],
    devTags: ['Hold'],
    frontIndex: 1000,
    basicFrontFile: 'Oreo Plushie.svg',
    holdingFrontFile: 'Oreo Plushie.svg',
  },
  {
    id: 248,
    name: 'Cauldron',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Cooking',
    searchableTags: [
      'New',
      'Halloween',
      'Witch',
      'Seasonal',
      'Cauldron',
      'Cooking',
      'Rear Accessory',
      'Green',
      'Black',
    ],
    devTags: [],
    frontIndex: 20000,
    basicFrontFile: 'Cauldron.svg',
  },
  {
    id: 206,
    name: 'Cat Ears',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Dress-Ups',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Cat Ears.svg',
  },
  {
    id: 69,
    name: 'Cat Ears - Black',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Dress-Ups',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Cat Ears - Black.svg',
  },
  {
    id: 342,
    name: 'Cat Ears - Black - Top',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Dress-Ups',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
  },
  {
    id: 290,
    name: 'Cat Ears - Top',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Dress-Ups',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
  },
  {
    id: 154,
    name: 'Dino Tail',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Dress-Ups',
    searchableTags: ['Dinosaur', 'Rear Accessory', 'Tail', 'Dino Tail', 'Green'],
    devTags: [],
    frontIndex: 20000,
    basicFrontFile: 'Dino Tail.svg',
  },
  {
    id: 72,
    name: 'Exclusive TKP Fairy Wings',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Dress-Ups',
    searchableTags: [
      'Wings',
      'Rear Accessory',
      'Head Accessory',
      'Fairy',
      'Dressup',
      'The Kindness Project',
      'White',
    ],
    devTags: [],
    frontIndex: 20000,
    basicFrontFile: 'Exclusive TKP Fairy Wings.svg',
  },
  {
    id: 19,
    name: 'Halo',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Dress-Ups',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Halo.svg',
  },
  {
    id: 350,
    name: 'Horns',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Dress-Ups',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Horns.svg',
  },
  {
    id: 190,
    name: 'Seasonal Bunny Ears',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Dress-Ups',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Seasonal Bunny Ears.svg',
  },
  {
    id: 284,
    name: 'Seasonal Elf Hat',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Dress-Ups',
    searchableTags: ['Green'],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Seasonal Elf Hat.svg',
  },
  {
    id: 260,
    name: 'Seasonal Pumpkin Head',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Dress-Ups',
    searchableTags: ['Hide Hair'],
    devTags: ['Hide Hair'],
    frontIndex: 1000,
    basicFrontFile: 'Seasonal Pumpkin Head.svg',
  },
  {
    id: 54,
    name: 'Seasonal Santa Hat',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Dress-Ups',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Seasonal Santa Hat.svg',
  },
  {
    id: 267,
    name: 'Witches Hat',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Dress-Ups',
    category3: 'Hat',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Witches Hat.svg',
  },
  {
    id: 155,
    name: '3D Glasses',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Eyewear',
    category3: 'Glasses',
    searchableTags: ['Glasses'],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: '3D Glasses.svg',
  },
  {
    id: 228,
    name: 'Bruh Glasses',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Eyewear',
    category3: 'Glasses',
    searchableTags: ['Glasses'],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Bruh Glasses.svg',
  },
  {
    id: 363,
    name: 'Full Frames',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Eyewear',
    category3: 'Glasses',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Full Frames.svg',
  },
  {
    id: 11,
    name: 'Half Circle Glasses',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Eyewear',
    category3: 'Glasses',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Half Circle Glasses.svg',
  },
  {
    id: 61,
    name: 'Heavy Framed Glasses',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Eyewear',
    category3: 'Glasses',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Heavy Framed Glasses.svg',
  },
  {
    id: 137,
    name: 'Monocle',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Eyewear',
    category3: 'Glasses',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Monocle.svg',
  },
  {
    id: 233,
    name: 'Noun Glasses',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Eyewear',
    category3: 'Glasses',
    searchableTags: ['New'],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Noun Glasses.svg',
  },
  {
    id: 223,
    name: 'Techie Monocle',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Eyewear',
    category3: 'Glasses',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Techie Monocle.svg',
  },
  {
    id: 382,
    name: 'Eye Patch',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Eyewear',
    category3: 'Patch',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Eye Patch.svg',
  },
  {
    id: 105,
    name: 'Medical Eye Patch',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Eyewear',
    category3: 'Patch',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Medical Eye Patch.svg',
  },
  {
    id: 288,
    name: 'Headphones',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Headwear',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Headphones.svg',
  },
  {
    id: 126,
    name: 'Beanie - Grey',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Headwear',
    category3: 'Beanie',
    searchableTags: ['Hat'],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Beanie - Grey.svg',
  },
  {
    id: 78,
    name: 'Beanie - Red',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Headwear',
    category3: 'Beanie',
    searchableTags: ['Hat'],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Beanie - Red.svg',
  },
  {
    id: 365,
    name: 'Beanie - Yellow',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Headwear',
    category3: 'Beanie',
    searchableTags: ['Hat'],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Beanie - Yellow.svg',
  },
  {
    id: 238,
    name: 'Large Bow',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Headwear',
    category3: 'Hair Accessory',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Large Bow.svg',
  },
  {
    id: 20,
    name: 'Star Clips',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Headwear',
    category3: 'Hair Accessory',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Star Clips.svg',
  },
  {
    id: 285,
    name: 'Tiare Flower',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Headwear',
    category3: 'Hair Accessory',
    searchableTags: ['New'],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Tiare Flower.svg',
  },
  {
    id: 304,
    name: 'Baseball Cap',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Headwear',
    category3: 'Hat',
    searchableTags: ['Hat'],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Baseball Cap.svg',
  },
  {
    id: 63,
    name: 'Beret',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Headwear',
    category3: 'Hat',
    searchableTags: ['Hat'],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Beret.svg',
  },
  {
    id: 127,
    name: 'Birthday Hat',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Headwear',
    category3: 'Hat',
    searchableTags: ['Hat', 'Birthday'],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Birthday Hat.svg',
  },
  {
    id: 366,
    name: 'Bucket Hat',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Headwear',
    category3: 'Hat',
    searchableTags: ['Hat'],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Bucket Hat.svg',
  },
  {
    id: 270,
    name: 'Chefs Hat',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Headwear',
    category3: 'Hat',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Chefs Hat.svg',
  },
  {
    id: 362,
    name: 'Exclusive CC Hat',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Headwear',
    category3: 'Hat',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Exclusive CC Hat.svg',
  },
  {
    id: 256,
    name: 'Exclusive CC Hat - Straw',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Headwear',
    category3: 'Hat',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
  },
  {
    id: 375,
    name: 'Fedora',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Headwear',
    category3: 'Hat',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Fedora.svg',
  },
  {
    id: 282,
    name: 'Fez',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Headwear',
    category3: 'Hat',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Fez.svg',
  },
  {
    id: 249,
    name: 'Graduation Cap',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Headwear',
    category3: 'Hat',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Graduation Cap.svg',
  },
  {
    id: 143,
    name: 'Hard Hat',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Headwear',
    category3: 'Hat',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Hard Hat.svg',
  },
  {
    id: 261,
    name: 'Navy Fedora',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Headwear',
    category3: 'Hat',
    searchableTags: ['New'],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Navy Fedora.svg',
  },
  {
    id: 230,
    name: 'Partyhat',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Headwear',
    category3: 'Hat',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Partyhat.svg',
  },
  {
    id: 237,
    name: 'Flower Headband',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Headwear',
    category3: 'Headband',
    searchableTags: ['New'],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Flower Headband.svg',
  },
  {
    id: 227,
    name: 'Solid Wine Headband',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Headwear',
    category3: 'Headband',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Solid Wine Headband.svg',
  },
  {
    id: 352,
    name: 'Unicorn Headband',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Headwear',
    category3: 'Headband',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Unicorn Headband.svg',
  },
  {
    id: 313,
    name: 'Headscarf',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Headwear',
    category3: 'Scarfs',
    searchableTags: ['Hide Hair', 'Blue', 'Black'],
    devTags: ['Hide Hair'],
    frontIndex: 1000,
    basicFrontFile: 'Headscarf.svg',
  },
  {
    id: 358,
    name: 'Handbag',
    stage: 'In Quality Control',
    category1: 'Accessory',
    category2: 'Holdables',
    category3: 'Bag',
    searchableTags: ['Hold'],
    devTags: ['Hold'],
    frontIndex: 1000,
    basicFrontFile: 'Handbag.svg',
    holdingFrontFile: 'Handbag.svg',
  },
  {
    id: 138,
    name: 'Laptop',
    stage: 'In Quality Control',
    category1: 'Accessory',
    category2: 'Holdables',
    category3: 'Devices',
    searchableTags: ['Hold'],
    devTags: ['Hold'],
    frontIndex: 1000,
    basicFrontFile: 'Laptop.svg',
    holdingFrontFile: 'Laptop.svg',
  },
  {
    id: 205,
    name: 'Coffee',
    stage: 'In Quality Control',
    category1: 'Accessory',
    category2: 'Holdables',
    category3: 'Drinks',
    searchableTags: ['Hold'],
    devTags: ['Hold'],
    frontIndex: 1000,
    basicFrontFile: 'Coffee.svg',
    holdingFrontFile: 'Coffee.svg',
  },
  {
    id: 116,
    name: 'Exclusive GCWC Rose Wine',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Holdables',
    category3: 'Drinks',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Exclusive GCWC Rose Wine.svg',
  },
  {
    id: 384,
    name: 'Sav Wine',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Holdables',
    category3: 'Drinks',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Sav Wine.svg',
  },
  {
    id: 81,
    name: 'Snifter',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Holdables',
    category3: 'Drinks',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Snifter.svg',
  },
  {
    id: 291,
    name: 'Ice Cream',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Holdables',
    category3: 'Food',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Ice Cream.svg',
  },
  {
    id: 231,
    name: 'Taco',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Holdables',
    category3: 'Food',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Taco.svg',
  },
  {
    id: 151,
    name: 'Controller',
    stage: 'In Quality Control',
    category1: 'Accessory',
    category2: 'Holdables',
    category3: 'Gaming',
    searchableTags: ['Hold'],
    devTags: ['Hold'],
    frontIndex: 1000,
    basicFrontFile: 'Controller.svg',
    holdingFrontFile: 'Controller.svg',
  },
  {
    id: 167,
    name: 'Balloonie',
    stage: 'In Quality Control',
    category1: 'Accessory',
    category2: 'Holdables',
    category3: 'Gifts',
    searchableTags: ['Hold'],
    devTags: ['Hold'],
    frontIndex: 1000,
    basicFrontFile: 'Balloonie.svg',
    holdingFrontFile: 'Balloonie.svg',
  },
  {
    id: 244,
    name: 'Plant',
    stage: 'In Quality Control',
    category1: 'Accessory',
    category2: 'Holdables',
    category3: 'Gifts',
    searchableTags: ['Hold'],
    devTags: ['Hold'],
    frontIndex: 1000,
    basicFrontFile: 'Plant.svg',
    holdingFrontFile: 'Plant.svg',
  },
  {
    id: 275,
    name: 'Present',
    stage: 'In Quality Control',
    category1: 'Accessory',
    category2: 'Holdables',
    category3: 'Gifts',
    searchableTags: ['Hold'],
    devTags: ['Hold'],
    frontIndex: 1000,
    basicFrontFile: 'Present.svg',
    holdingFrontFile: 'Present.svg',
  },
  {
    id: 333,
    name: 'Sunflowers',
    stage: 'In Quality Control',
    category1: 'Accessory',
    category2: 'Holdables',
    category3: 'Gifts',
    searchableTags: ['Hold'],
    devTags: ['Hold'],
    frontIndex: 1000,
    basicFrontFile: 'Sunflowers.svg',
    holdingFrontFile: 'Sunflowers.svg',
  },
  {
    id: 43,
    name: 'Paintbrush',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Holdables',
    category3: 'Tools',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Paintbrush.svg',
  },
  {
    id: 339,
    name: 'Shovel',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Holdables',
    category3: 'Tools',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Shovel.svg',
  },
  {
    id: 305,
    name: 'Umbrella',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Holdables',
    category3: 'Umbrella',
    searchableTags: ['New'],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Umbrella.svg',
  },
  {
    id: 332,
    name: 'Black Pearl Earrings',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Jewellery',
    category3: 'Earrings',
    searchableTags: ['New', 'Earrings', 'Jewelery'],
    devTags: [],
    frontIndex: 1500,
    basicFrontFile: 'Black Pearl Earrings.svg',
  },
  {
    id: 320,
    name: 'Bone Earrings',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Jewellery',
    category3: 'Earrings',
    searchableTags: ['Earrings'],
    devTags: [],
    frontIndex: 1500,
    basicFrontFile: 'Bone Earrings.svg',
  },
  {
    id: 354,
    name: 'Dangling Earrings',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Jewellery',
    category3: 'Earrings',
    searchableTags: [],
    devTags: [],
    frontIndex: 1500,
    basicFrontFile: 'Dangling Earrings.svg',
  },
  {
    id: 146,
    name: 'Diamond Earrings',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Jewellery',
    category3: 'Earrings',
    searchableTags: [],
    devTags: [],
    frontIndex: 1500,
    basicFrontFile: 'Diamond Earrings.svg',
  },
  {
    id: 65,
    name: 'Hoop Earrings',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Jewellery',
    category3: 'Earrings',
    searchableTags: [],
    devTags: [],
    frontIndex: 1500,
    basicFrontFile: 'Hoop Earrings.svg',
  },
  {
    id: 96,
    name: 'Black Pearl Necklace',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Jewellery',
    category3: 'Necklace',
    searchableTags: ['New', 'Necklace', 'Jewelery'],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Black Pearl Necklace.svg',
  },
  {
    id: 271,
    name: 'Nose Ring',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Jewellery',
    category3: 'Piercings',
    searchableTags: ['Jewelery', 'Piercing', 'Silver', 'Grey'],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Nose Ring.svg',
  },
  {
    id: 42,
    name: 'Black Pearl Set',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Jewellery',
    category3: 'Set',
    searchableTags: ['New', 'Jewelery'],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Black Pearl Set.svg',
  },
  {
    id: 106,
    name: 'Crutches',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Mobility',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Crutches.svg',
  },
  {
    id: 141,
    name: 'Walking Stick',
    stage: 'In Quality Control',
    category1: 'Accessory',
    category2: 'Mobility',
    searchableTags: ['Hold'],
    devTags: ['Hold'],
    frontIndex: 1000,
    basicFrontFile: 'Walking Stick.svg',
    holdingFrontFile: 'Walking Stick.svg',
  },
  {
    id: 24,
    name: 'Peace Sign',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Signs',
    searchableTags: ['Rear Accessory', 'Sign', 'Protest', 'Peace', 'Rainbow'],
    devTags: [],
    frontIndex: 20000,
    basicFrontFile: 'Peace Sign.svg',
  },
  {
    id: 262,
    name: 'Protest Sign',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Signs',
    searchableTags: ['Protest Sign', 'Rear Accessory', 'Sign', 'Protest', 'Purple', 'Black'],
    devTags: [],
    frontIndex: 20000,
    basicFrontFile: 'Protest Sign.svg',
  },
  {
    id: 298,
    name: 'Protest Sign Writing',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Signs',
    searchableTags: [
      'Protest Sign',
      'Rear Accessory',
      'Sign',
      'Protest',
      'Writing',
      'Sign Writing',
      'Black',
    ],
    devTags: [],
    frontIndex: 20000,
    basicFrontFile: 'Protest Sign Writing.svg',
  },
  {
    id: 62,
    name: 'Baseball Bat',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Sports Equipment',
    searchableTags: ['Sport', 'Bat'],
    devTags: [],
    frontIndex: 4500,
    basicFrontFile: 'Baseball Bat.svg',
  },
  {
    id: 170,
    name: 'Basketball',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Sports Equipment',
    searchableTags: ['Sport', 'Ball'],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Basketball.svg',
  },
  {
    id: 353,
    name: 'Fishing Rod',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Sports Equipment',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Fishing Rod.svg',
  },
  {
    id: 76,
    name: 'Golf Bag',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Sports Equipment',
    searchableTags: [
      'Sport',
      'Sports Equipment',
      'Golf',
      'Bag',
      'Golf Bag',
      'Rear Accessory',
      'Blue',
      'Yellow',
      'Pink',
      'Orange',
    ],
    devTags: [],
    frontIndex: 20000,
    basicFrontFile: 'Golf Bag.svg',
  },
  {
    id: 108,
    name: 'Rugby Ball',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Sports Equipment',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Rugby Ball.svg',
  },
  {
    id: 166,
    name: 'Soccer Ball',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Sports Equipment',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Soccer Ball.svg',
  },
  {
    id: 34,
    name: 'Surfboard',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Sports Equipment',
    searchableTags: [
      'Sport',
      'Sports Equipment',
      'Surfboard',
      'Beach',
      'Water',
      'Grey',
      'Yellow',
      'White',
    ],
    devTags: [],
    frontIndex: 20000,
    basicFrontFile: 'Surfboard.svg',
  },
  {
    id: 241,
    name: 'Tennis Racket',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Sports Equipment',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Tennis Racket.svg',
  },
  {
    id: 173,
    name: 'Volleyball',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Sports Equipment',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Volleyball.svg',
  },
  {
    id: 316,
    name: 'Stethoscope',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Tools',
    searchableTags: [],
    devTags: [],
    frontIndex: 1000,
    basicFrontFile: 'Stethoscope.svg',
  },
  {
    id: 344,
    name: 'Tool Belt',
    stage: 'Final',
    category1: 'Accessory',
    category2: 'Tools',
    searchableTags: [],
    devTags: [],
    frontIndex: 6000,
    basicFrontFile: 'Tool Belt.svg',
  },
  {
    id: 101,
    name: 'Annoyed',
    stage: 'Final',
    category1: 'Body',
    category2: 'Expression',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 3000,
    basicFrontFile: 'Annoyed.svg',
  },
  {
    id: 35,
    name: 'Bloody Tears',
    stage: 'Final',
    category1: 'Body',
    category2: 'Expression',
    searchableTags: ['New', 'Halloween', 'Seasonal', 'Blood', 'Red', 'Tears', 'Expression'],
    devTags: ['hidden_opensea'],
    frontIndex: 3000,
    basicFrontFile: 'Bloody Tears.svg',
  },
  {
    id: 181,
    name: 'Blush',
    stage: 'Final',
    category1: 'Body',
    category2: 'Expression',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 3000,
    basicFrontFile: 'Blush.svg',
  },
  {
    id: 41,
    name: 'Concentrate',
    stage: 'Final',
    category1: 'Body',
    category2: 'Expression',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 3000,
    basicFrontFile: 'Concentrate.svg',
  },
  {
    id: 322,
    name: 'Erm',
    stage: 'Final',
    category1: 'Body',
    category2: 'Expression',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 3000,
    basicFrontFile: 'Erm.svg',
  },
  {
    id: 148,
    name: 'Fangs',
    stage: 'Final',
    category1: 'Body',
    category2: 'Expression',
    searchableTags: [
      'New',
      'Halloween',
      'Seasonal',
      'Fang',
      'Blood',
      'Red',
      'Teeth',
      'White',
      'Expression',
    ],
    devTags: ['hidden_opensea'],
    frontIndex: 3000,
    basicFrontFile: 'Fangs.svg',
  },
  {
    id: 247,
    name: 'Freaked Out',
    stage: 'Final',
    category1: 'Body',
    category2: 'Expression',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 3000,
    basicFrontFile: 'Freaked Out.svg',
  },
  {
    id: 180,
    name: 'Full Lips',
    stage: 'Final',
    category1: 'Body',
    category2: 'Expression',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 3000,
    basicFrontFile: 'Full Lips.svg',
  },
  {
    id: 120,
    name: 'Gentle Smile',
    stage: 'Final',
    category1: 'Body',
    category2: 'Expression',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 3000,
    basicFrontFile: 'Gentle Smile.svg',
  },
  {
    id: 71,
    name: 'Humph',
    stage: 'Final',
    category1: 'Body',
    category2: 'Expression',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 3000,
    basicFrontFile: 'Humph.svg',
  },
  {
    id: 314,
    name: 'Joy',
    stage: 'Final',
    category1: 'Body',
    category2: 'Expression',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 3000,
    basicFrontFile: 'Joy.svg',
  },
  {
    id: 89,
    name: 'Mad',
    stage: 'Final',
    category1: 'Body',
    category2: 'Expression',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 3000,
    basicFrontFile: 'Mad.svg',
  },
  {
    id: 114,
    name: 'Meow',
    stage: 'Final',
    category1: 'Body',
    category2: 'Expression',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 3000,
    basicFrontFile: 'Meow.svg',
  },
  {
    id: 176,
    name: 'Oh!',
    stage: 'Final',
    category1: 'Body',
    category2: 'Expression',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 3000,
    basicFrontFile: 'Oh!.svg',
  },
  {
    id: 90,
    name: 'Sad',
    stage: 'Final',
    category1: 'Body',
    category2: 'Expression',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 3000,
    basicFrontFile: 'Sad.svg',
  },
  {
    id: 220,
    name: 'Shocked',
    stage: 'Bug',
    category1: 'Body',
    category2: 'Expression',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 3000,
    basicFrontFile: 'Shocked.svg',
  },
  {
    id: 265,
    name: 'Tongue Out',
    stage: 'Final',
    category1: 'Body',
    category2: 'Expression',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 3000,
    basicFrontFile: 'Tongue Out.svg',
  },
  {
    id: 222,
    name: 'Vamp Smile',
    stage: 'Final',
    category1: 'Body',
    category2: 'Expression',
    searchableTags: [
      'New',
      'Expression',
      'Halloween',
      'Seasonal',
      'Vampire',
      'Fang',
      'Smile',
      'Teeth',
      'White',
    ],
    devTags: ['hidden_opensea'],
    frontIndex: 3000,
    basicFrontFile: 'Vamp Smile.svg',
  },
  {
    id: 346,
    name: 'Black',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Colour',
    searchableTags: ['Eye Colour', 'Human', 'Face', 'Eyes'],
    devTags: ['hidden_opensea'],
    frontIndex: 15000,
    basicFrontFile: 'Black.svg',
  },
  {
    id: 179,
    name: 'Blue',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Colour',
    searchableTags: ['Eye Colour', 'Human', 'Face', 'Eyes'],
    devTags: ['hidden_opensea'],
    frontIndex: 15000,
    basicFrontFile: 'Blue Green.svg',
  },
  {
    id: 50,
    name: 'Blue Green',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Colour',
    searchableTags: ['Eye Colour', 'Human', 'Face', 'Eyes'],
    devTags: ['hidden_opensea'],
    frontIndex: 15000,
    basicFrontFile: 'Blue Grey.svg',
  },
  {
    id: 55,
    name: 'Blue Grey',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Colour',
    searchableTags: ['Eye Colour', 'Human', 'Face', 'Eyes'],
    devTags: ['hidden_opensea'],
    frontIndex: 15000,
    basicFrontFile: 'Blue.svg',
  },
  {
    id: 341,
    name: 'Brown',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Colour',
    searchableTags: ['Eye Colour', 'Human', 'Face', 'Eyes'],
    devTags: ['hidden_opensea'],
    frontIndex: 15000,
    basicFrontFile: 'Brown.svg',
  },
  {
    id: 186,
    name: 'Brown Gold',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Colour',
    searchableTags: ['Eye Colour', 'Human', 'Face', 'Eyes'],
    devTags: ['hidden_opensea'],
    frontIndex: 15000,
    basicFrontFile: 'Brown Gold.svg',
  },
  {
    id: 297,
    name: 'Brown Grey',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Colour',
    searchableTags: ['Eye Colour', 'Human', 'Face', 'Eyes'],
    devTags: ['hidden_opensea'],
    frontIndex: 15000,
    basicFrontFile: 'Brown Grey.svg',
  },
  {
    id: 212,
    name: 'Brown Hazel',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Colour',
    searchableTags: ['Eye Colour', 'Human', 'Face', 'Eyes'],
    devTags: ['hidden_opensea'],
    frontIndex: 15000,
  },
  {
    id: 187,
    name: 'Dark Brown',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Colour',
    searchableTags: ['Eye Colour', 'Human', 'Face', 'Eyes'],
    devTags: ['hidden_opensea'],
    frontIndex: 15000,
    basicFrontFile: 'Dark Brown.svg',
  },
  {
    id: 368,
    name: 'Galaxy',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Colour',
    searchableTags: ['Eye Colour', 'Face', 'Eyes', 'Multi', 'Space', 'Galaxy'],
    devTags: ['hidden_opensea'],
    frontIndex: 15000,
    basicFrontFile: 'Galaxy.svg',
  },
  {
    id: 74,
    name: 'Green',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Colour',
    searchableTags: ['Eye Colour', 'Human', 'Face', 'Eyes'],
    devTags: ['hidden_opensea'],
    frontIndex: 15000,
    basicFrontFile: 'Green.svg',
  },
  {
    id: 87,
    name: 'Grey',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Colour',
    searchableTags: ['Eye Colour', 'Human', 'Face', 'Eyes'],
    devTags: ['hidden_opensea'],
    frontIndex: 15000,
    basicFrontFile: 'Grey.svg',
  },
  {
    id: 140,
    name: 'Hazel',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Colour',
    searchableTags: ['Eye Colour', 'Human', 'Face', 'Eyes'],
    devTags: ['hidden_opensea'],
    frontIndex: 15000,
    basicFrontFile: 'Hazel.svg',
  },
  {
    id: 280,
    name: 'Purple',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Colour',
    searchableTags: ['Eye Colour', 'Human', 'Face', 'Eyes'],
    devTags: ['hidden_opensea'],
    frontIndex: 15000,
    basicFrontFile: 'Purple.svg',
  },
  {
    id: 324,
    name: 'Rainbow Circular',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Colour',
    searchableTags: ['Eye Colour', 'Face', 'Eyes', 'Multi', 'Rainbow'],
    devTags: ['hidden_opensea'],
    frontIndex: 15000,
    basicFrontFile: 'Rainbow Circular.svg',
  },
  {
    id: 300,
    name: 'Rainbow Vertical',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Colour',
    searchableTags: ['Eye Colour', 'Face', 'Eyes', 'Multi', 'Rainbow'],
    devTags: ['hidden_opensea'],
    frontIndex: 15000,
    basicFrontFile: 'Rainbow Vertical.svg',
  },
  {
    id: 200,
    name: 'Classic Eyelashes',
    stage: 'Bug',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Lashes',
    searchableTags: ['Eyelashes', 'Classic', 'Lashes'],
    devTags: ['hidden_opensea'],
    frontIndex: 13000,
    basicFrontFile: 'Classic Eyelashes.svg',
  },
  {
    id: 337,
    name: 'Fancy Eyelashes',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Lashes',
    searchableTags: ['Eyelashes', 'Lashes', 'Fancy'],
    devTags: ['hidden_opensea'],
    frontIndex: 13000,
    basicFrontFile: 'Fancy Eyelashes.svg',
  },
  {
    id: 175,
    name: 'Outline',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Lashes',
    searchableTags: ['Basic', 'Eyelashes', 'Lashes'],
    devTags: ['hidden_opensea'],
    frontIndex: 13000,
    basicFrontFile: 'Outline.svg',
  },
  {
    id: 279,
    name: 'Ahh',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Style',
    searchableTags: ['Eye Style', 'Reflections'],
    devTags: ['hidden_opensea'],
    frontIndex: 14000,
    basicFrontFile: 'Ahh.svg',
  },
  {
    id: 216,
    name: 'Bean',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Style',
    searchableTags: ['Eye Style', 'Reflections'],
    devTags: ['hidden_opensea'],
    frontIndex: 14000,
    basicFrontFile: 'Bean.svg',
  },
  {
    id: 93,
    name: 'Big Pupils',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Style',
    searchableTags: ['Eye Style', 'Reflections'],
    devTags: ['hidden_opensea'],
    frontIndex: 14000,
    basicFrontFile: 'Big Pupils.svg',
  },
  {
    id: 385,
    name: 'Blue Delight',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Style',
    searchableTags: ['Eye Style', 'Reflections', 'Blue'],
    devTags: ['hidden_opensea'],
    frontIndex: 14000,
    basicFrontFile: 'Blue Delight.svg',
  },
  {
    id: 163,
    name: 'Boomarang',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Style',
    searchableTags: ['Eye Style', 'Reflections', 'Pink'],
    devTags: ['hidden_opensea'],
    frontIndex: 14000,
    basicFrontFile: 'Boomarang.svg',
  },
  {
    id: 273,
    name: 'Bow',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Style',
    searchableTags: ['Eye Style', 'Reflections'],
    devTags: ['hidden_opensea'],
    frontIndex: 14000,
    basicFrontFile: 'Bow.svg',
  },
  {
    id: 209,
    name: 'Classic',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Style',
    searchableTags: ['Classic', 'Eye Style', 'Reflections'],
    devTags: ['hidden_opensea'],
    frontIndex: 14000,
    basicFrontFile: 'Classic.svg',
  },
  {
    id: 242,
    name: 'Cutie Pie',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Style',
    searchableTags: ['Eye Style', 'Reflections'],
    devTags: ['hidden_opensea'],
    frontIndex: 14000,
    basicFrontFile: 'Cutie Pie.svg',
  },
  {
    id: 219,
    name: 'Dot Flares',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Style',
    searchableTags: ['Eye Style', 'Reflections'],
    devTags: ['hidden_opensea'],
    frontIndex: 14000,
    basicFrontFile: 'Dot Flares.svg',
  },
  {
    id: 45,
    name: 'Fantasy',
    stage: 'Bug',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Style',
    searchableTags: ['Eye Style', 'Reflections'],
    devTags: ['hidden_opensea'],
    frontIndex: 14000,
    basicFrontFile: 'Fantasy.svg',
  },
  {
    id: 203,
    name: 'Lightning',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Style',
    searchableTags: ['Eye Style', 'Reflections', 'Yellow'],
    devTags: ['hidden_opensea'],
    frontIndex: 14000,
    basicFrontFile: 'Lightning.svg',
  },
  {
    id: 2,
    name: 'Love',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Style',
    searchableTags: ['Eye Style', 'Reflections', 'Pink'],
    devTags: ['hidden_opensea'],
    frontIndex: 14000,
    basicFrontFile: 'Love.svg',
  },
  {
    id: 340,
    name: 'Orange Flare',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Style',
    searchableTags: ['Eye Style', 'Reflections'],
    devTags: ['hidden_opensea'],
    frontIndex: 14000,
    basicFrontFile: 'Orange Flare.svg',
  },
  {
    id: 159,
    name: 'Shooting Stars',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Style',
    searchableTags: ['Eye Style', 'Reflections', 'Orange'],
    devTags: ['hidden_opensea'],
    frontIndex: 14000,
    basicFrontFile: 'Shooting Stars.svg',
  },
  {
    id: 168,
    name: 'Slick',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Style',
    searchableTags: ['Eye Style', 'Reflections', 'Pink'],
    devTags: ['hidden_opensea'],
    frontIndex: 14000,
    basicFrontFile: 'Slick.svg',
  },
  {
    id: 38,
    name: 'Sparkles',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Style',
    searchableTags: ['Eye Style', 'Reflections', 'Blue'],
    devTags: ['hidden_opensea'],
    frontIndex: 14000,
    basicFrontFile: 'Sparkles.svg',
  },
  {
    id: 286,
    name: 'Stars',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Style',
    searchableTags: ['Eye Style', 'Reflections', 'Yellow'],
    devTags: ['hidden_opensea'],
    frontIndex: 14000,
    basicFrontFile: 'Stars.svg',
  },
  {
    id: 145,
    name: 'Sweetie',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Style',
    searchableTags: ['Eye Style', 'Reflections', 'Red'],
    devTags: ['hidden_opensea'],
    frontIndex: 14000,
    basicFrontFile: 'Sweetie.svg',
  },
  {
    id: 374,
    name: 'Swirls',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Style',
    searchableTags: ['Eye Style', 'Reflections'],
    devTags: ['hidden_opensea'],
    frontIndex: 14000,
    basicFrontFile: 'Swirls.svg',
  },
  {
    id: 23,
    name: 'Twin Stars',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Style',
    searchableTags: ['Eye Style', 'Reflections', 'Yellow'],
    devTags: ['hidden_opensea'],
    frontIndex: 14000,
    basicFrontFile: 'Twin Stars.svg',
  },
  {
    id: 274,
    name: 'Windmill',
    stage: 'Final',
    category1: 'Body',
    category2: 'Eyes',
    category3: 'Style',
    searchableTags: ['Eye Style', 'Reflections'],
    devTags: ['hidden_opensea'],
    frontIndex: 14000,
    basicFrontFile: 'Windmill.svg',
  },
  {
    id: 135,
    name: 'Fluffy Beard',
    stage: 'Final',
    category1: 'Body',
    category2: 'Facial Hair',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 4000,
    basicFrontFile: 'Fluffy Beard.svg',
  },
  {
    id: 47,
    name: 'Full Beard',
    stage: 'Final',
    category1: 'Body',
    category2: 'Facial Hair',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 4000,
    basicFrontFile: 'Full Beard.svg',
  },
  {
    id: 347,
    name: 'Monobrow',
    stage: 'Final',
    category1: 'Body',
    category2: 'Facial Hair',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 2000,
    basicFrontFile: 'Monobrow.svg',
  },
  {
    id: 6,
    name: 'Moustache',
    stage: 'Bug',
    category1: 'Body',
    category2: 'Facial Hair',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 2000,
    basicFrontFile: 'Moustache.svg',
  },
  {
    id: 278,
    name: 'Shadow',
    stage: 'Final',
    category1: 'Body',
    category2: 'Facial Hair',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 4000,
    basicFrontFile: 'Shadow.svg',
  },
  {
    id: 240,
    name: 'Shaped Beard',
    stage: 'Final',
    category1: 'Body',
    category2: 'Facial Hair',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 4000,
    basicFrontFile: 'Shaped Beard.svg',
  },
  {
    id: 355,
    name: 'Amethyst',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Colour',
    searchableTags: [],
    devTags: ['hidden_opensea'],
  },
  {
    id: 234,
    name: 'Auburn',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Colour',
    searchableTags: [],
    devTags: ['hidden_opensea'],
  },
  {
    id: 110,
    name: 'Black',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Colour',
    searchableTags: [],
    devTags: ['hidden_opensea'],
  },
  {
    id: 158,
    name: 'Blonde',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Colour',
    searchableTags: [],
    devTags: ['hidden_opensea'],
  },
  {
    id: 15,
    name: 'Blue',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Colour',
    searchableTags: [],
    devTags: ['hidden_opensea'],
  },
  {
    id: 207,
    name: 'Copper',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Colour',
    searchableTags: [],
    devTags: ['hidden_opensea'],
  },
  {
    id: 66,
    name: 'Dark Brown',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Colour',
    searchableTags: [],
    devTags: ['hidden_opensea'],
  },
  {
    id: 177,
    name: 'Green',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Colour',
    searchableTags: [],
    devTags: ['hidden_opensea'],
  },
  {
    id: 115,
    name: 'Grey',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Colour',
    searchableTags: [],
    devTags: ['hidden_opensea'],
  },
  {
    id: 335,
    name: 'Light Brown',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Colour',
    searchableTags: [],
    devTags: ['hidden_opensea'],
  },
  {
    id: 3,
    name: 'Mid Brown',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Colour',
    searchableTags: [],
    devTags: ['hidden_opensea'],
  },
  {
    id: 312,
    name: 'Mousey',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Colour',
    searchableTags: [],
    devTags: ['hidden_opensea'],
  },
  {
    id: 156,
    name: 'Pale Green',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Colour',
    searchableTags: [],
    devTags: ['hidden_opensea'],
  },
  {
    id: 299,
    name: 'Pink',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Colour',
    searchableTags: [],
    devTags: ['hidden_opensea'],
  },
  {
    id: 121,
    name: 'Platinum',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Colour',
    searchableTags: [],
    devTags: ['hidden_opensea'],
  },
  {
    id: 257,
    name: 'Purple',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Colour',
    searchableTags: [],
    devTags: ['hidden_opensea'],
  },
  {
    id: 153,
    name: 'Teal',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Colour',
    searchableTags: [],
    devTags: ['hidden_opensea'],
  },
  {
    id: 109,
    name: 'Asymmetric Sweep',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Left Lashes Above'],
    devTags: ['Left Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Asymetric Sweep.svg',
  },
  {
    id: 331,
    name: 'Bald',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Left Lashes Above', 'Right Lashes Above'],
    devTags: ['Left Lashes Above', 'Right Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Bald.svg',
  },
  {
    id: 268,
    name: 'Box Braids',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Right Lashes Above'],
    devTags: ['Right Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Box Braids.svg',
  },
  {
    id: 318,
    name: 'Clean Cut',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Left Lashes Above', 'Right Lashes Above'],
    devTags: ['Left Lashes Above', 'Right Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Clean Cut.svg',
  },
  {
    id: 51,
    name: 'Costanza',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Left Lashes Above', 'Right Lashes Above'],
    devTags: ['Left Lashes Above', 'Right Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Costanza.svg',
  },
  {
    id: 367,
    name: 'Draculocks',
    stage: 'Art Updates',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: [
      'New',
      'Halloween',
      'Dracula',
      'Hair',
      'Seasonal',
      'White',
      'Left Lashes Above',
      'Right Lashes Above',
    ],
    devTags: ['Left Lashes Above', 'Right Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Draculocks.svg',
  },
  {
    id: 276,
    name: 'Frankenstein',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: [
      'New',
      'Halloween',
      'Seasonal',
      'Frankenstein',
      'White',
      'Hair',
      'Left Lashes Above',
      'Right Lashes Above',
    ],
    devTags: ['Left Lashes Above', 'Right Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Frankenstein.svg',
  },
  {
    id: 68,
    name: 'High Bun Locks',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Right Lashes Above'],
    devTags: ['Right Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'High Bun Locks.svg',
  },
  {
    id: 376,
    name: 'Long Curls',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Right Lashes Above'],
    devTags: ['Right Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Long Curls.svg',
  },
  {
    id: 296,
    name: 'Long Straight',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Left Lashes Above'],
    devTags: ['Left Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Long Straight.svg',
  },
  {
    id: 197,
    name: 'Loose Dreads',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Right Lashes Above'],
    devTags: ['Right Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Loose Dreads.svg',
  },
  {
    id: 56,
    name: 'Messy Bun',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Right Lashes Above', 'Left Lashes Above'],
    devTags: ['Right Lashes Above', 'Left Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Messy Bun.svg',
  },
  {
    id: 292,
    name: 'Mohawk',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Right Lashes Above', 'Left Lashes Above'],
    devTags: ['Right Lashes Above', 'Left Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Mohawk.svg',
  },
  {
    id: 277,
    name: 'Moms Signature',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Right Lashes Above'],
    devTags: ['Right Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Moms Signature.svg',
  },
  {
    id: 194,
    name: 'Mullet',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Left Lashes Above', 'Right Lashes Above'],
    devTags: ['Left Lashes Above', 'Right Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Mullet.svg',
  },
  {
    id: 57,
    name: 'Pigtails',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Right Lashes Above'],
    devTags: ['Right Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Pigtails.svg',
  },
  {
    id: 79,
    name: 'Pompadour',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Right Lashes Above', 'Left Lashes Above'],
    devTags: ['Right Lashes Above', 'Left Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Pompadour.svg',
  },
  {
    id: 255,
    name: 'Pulled Back Ponytail',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Right Lashes Above', 'Left Lashes Above'],
    devTags: ['Right Lashes Above', 'Left Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Pulled Back Ponytail.svg',
  },
  {
    id: 150,
    name: 'Quiff',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Right Lashes Above', 'Left Lashes Above'],
    devTags: ['Right Lashes Above', 'Left Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Quiff.svg',
  },
  {
    id: 301,
    name: 'Short Curls',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Right Lashes Above'],
    devTags: ['Right Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Short Curls.svg',
  },
  {
    id: 157,
    name: 'Short Fade',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Right Lashes Above', 'Left Lashes Above'],
    devTags: ['Right Lashes Above', 'Left Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Short Fade.svg',
  },
  {
    id: 48,
    name: 'Short Messy',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Short Messy.svg',
  },
  {
    id: 392,
    name: 'Short Neat',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: [],
    devTags: [],
    frontIndex: 12000,
    basicFrontFile: 'Short Neat.svg',
  },
  {
    id: 306,
    name: 'Short Side Swept',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Left Lashes Above'],
    devTags: ['Left Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Short Side Swept.svg',
  },
  {
    id: 26,
    name: 'Side Ponytail',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Right Lashes Above'],
    devTags: ['Right Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Side Ponytail.svg',
  },
  {
    id: 370,
    name: 'Space Buns',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Right Lashes Above', 'Left Lashes Above'],
    devTags: ['Right Lashes Above', 'Left Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Space Buns.svg',
  },
  {
    id: 9,
    name: 'Spikey',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Right Lashes Above', 'Left Lashes Above'],
    devTags: ['Right Lashes Above', 'Left Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Spikey.svg',
  },
  {
    id: 30,
    name: 'Straight Mid',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Right Lashes Above'],
    devTags: ['Right Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Straight Mid.svg',
  },
  {
    id: 27,
    name: 'Tousled',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Right Lashes Above', 'Left Lashes Above'],
    devTags: ['Right Lashes Above', 'Left Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Tousled.svg',
  },
  {
    id: 225,
    name: 'Twin Braids',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Right Lashes Above', 'Left Lashes Above'],
    devTags: ['Right Lashes Above', 'Left Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Twin Braids.svg',
  },
  {
    id: 169,
    name: 'Wavy Curls',
    stage: 'Final',
    category1: 'Body',
    category2: 'Hair',
    category3: 'Style',
    searchableTags: ['Right Lashes Above', 'Left Lashes Above'],
    devTags: ['Right Lashes Above', 'Left Lashes Above', 'hidden_opensea'],
    frontIndex: 12000,
    basicFrontFile: 'Wavy Curls.svg',
  },
  {
    id: 201,
    name: 'Asymmetric Vitiligo',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Characteristics',
    searchableTags: ['Skin Condition', 'Vitiligo', 'Asymmetric'],
    devTags: ['hidden_opensea'],
    frontIndex: 18500,
    basicFrontFile: 'Asymmetric Vitiligo.svg',
  },
  {
    id: 129,
    name: 'Beauty Mark Eye',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Characteristics',
    searchableTags: ['Skin Condition', 'Beauty Mark'],
    devTags: ['hidden_opensea'],
    frontIndex: 18000,
    basicFrontFile: 'Beauty Mark Eye.svg',
  },
  {
    id: 208,
    name: 'Beauty Mark Lip',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Characteristics',
    searchableTags: ['Skin Condition', 'Beauty Mark'],
    devTags: ['hidden_opensea'],
    frontIndex: 18000,
    basicFrontFile: 'Beauty Mark Lip.svg',
  },
  {
    id: 250,
    name: 'Freckles',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Characteristics',
    searchableTags: ['Skin Condition', 'Freckles'],
    devTags: ['hidden_opensea'],
    frontIndex: 18500,
    basicFrontFile: 'Freckles.svg',
  },
  {
    id: 142,
    name: 'Full Freckles',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Characteristics',
    searchableTags: ['Skin Condition', 'Freckles'],
    devTags: ['hidden_opensea'],
    frontIndex: 18500,
    basicFrontFile: 'Full Freckles.svg',
  },
  {
    id: 372,
    name: 'Patchwork',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Characteristics',
    searchableTags: [
      'New',
      'Halloween',
      'Seasonal',
      'Skin Condition',
      'Pink',
      'Stitches',
      'Injury',
      'Frankenstein',
      'Makeup',
    ],
    devTags: ['hidden_opensea'],
    frontIndex: 18500,
    basicFrontFile: 'Patchwork.svg',
  },
  {
    id: 323,
    name: 'Scar',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Characteristics',
    searchableTags: ['New', 'Halloween', 'Seasonal', 'Skin Condition', 'Scar', 'Injury'],
    devTags: ['hidden_opensea'],
    frontIndex: 18000,
    basicFrontFile: 'Scar.svg',
  },
  {
    id: 103,
    name: 'Stitches',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Characteristics',
    searchableTags: [
      'New',
      'Halloween',
      'Seasonal',
      'Skin Condition',
      'Injury',
      'Stitches',
      'Frankenstein',
      'Makeup',
    ],
    devTags: ['hidden_opensea'],
    frontIndex: 18000,
    basicFrontFile: 'Stitches.svg',
  },
  {
    id: 263,
    name: 'Symmetric Vitiligo',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Characteristics',
    searchableTags: ['Skin Condition', 'Vitiligo', 'Symmetric'],
    devTags: ['hidden_opensea'],
    frontIndex: 18500,
    basicFrontFile: 'Symmetric Vitiligo.svg',
  },
  {
    id: 259,
    name: 'Alien',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Tone',
    searchableTags: ['Skin', 'Skin Tone', 'Alien', 'New', 'Halloween', 'Green'],
    devTags: ['hidden_opensea'],
  },
  {
    id: 192,
    name: 'Almond',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Tone',
    searchableTags: ['Skin', 'Skin Tone', 'Human', 'Tan'],
    devTags: ['hidden_opensea'],
  },
  {
    id: 136,
    name: 'Band',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Tone',
    searchableTags: ['Skin', 'Skin Tone', 'Human', 'Tan'],
    devTags: ['hidden_opensea'],
  },
  {
    id: 217,
    name: 'Beige',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Tone',
    searchableTags: ['Skin', 'Skin Tone', 'Human', 'Pale'],
    devTags: ['hidden_opensea'],
  },
  {
    id: 383,
    name: 'Blue',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Tone',
    searchableTags: ['Skin', 'Skin Tone', 'Alien', 'Blue', 'Halloween', 'New'],
    devTags: ['hidden_opensea'],
  },
  {
    id: 117,
    name: 'Bronze',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Tone',
    searchableTags: ['Skin', 'Skin Tone', 'Human', 'Dark'],
    devTags: ['hidden_opensea'],
  },
  {
    id: 221,
    name: 'Chestnut',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Tone',
    searchableTags: ['Skin', 'Skin Tone', 'Human', 'Dark'],
    devTags: ['hidden_opensea'],
  },
  {
    id: 111,
    name: 'Chocolate',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Tone',
    searchableTags: ['Skin', 'Skin Tone', 'Human', 'Dark'],
    devTags: ['hidden_opensea'],
  },
  {
    id: 85,
    name: 'Espresso',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Tone',
    searchableTags: ['Skin', 'Skin Tone', 'Human', 'Dark'],
    devTags: ['hidden_opensea'],
  },
  {
    id: 165,
    name: 'Ghoul',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Tone',
    searchableTags: ['Skin', 'Skin Tone', 'Ghoul', 'Halloween', 'Pale', 'New'],
    devTags: ['hidden_opensea'],
  },
  {
    id: 188,
    name: 'Golden',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Tone',
    searchableTags: ['Skin', 'Skin Tone', 'Human', 'Dark'],
    devTags: ['hidden_opensea'],
  },
  {
    id: 131,
    name: 'Honey',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Tone',
    searchableTags: ['Skin', 'Skin Tone', 'Human', 'Tan'],
    devTags: ['hidden_opensea'],
  },
  {
    id: 189,
    name: 'Ivory',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Tone',
    searchableTags: ['Skin', 'Skin Tone', 'Human', 'Pale'],
    devTags: ['hidden_opensea'],
  },
  {
    id: 369,
    name: 'Limestone',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Tone',
    searchableTags: ['Skin', 'Skin Tone', 'Human', 'Pale'],
    devTags: ['hidden_opensea'],
  },
  {
    id: 134,
    name: 'Pale Ivory',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Tone',
    searchableTags: ['Skin', 'Skin Tone', 'Human', 'Pale'],
    devTags: ['hidden_opensea'],
  },
  {
    id: 326,
    name: 'Porcelain',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Tone',
    searchableTags: ['Skin', 'Skin Tone', 'Human', 'Pale'],
    devTags: ['hidden_opensea'],
  },
  {
    id: 348,
    name: 'Rose Beige',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Tone',
    searchableTags: ['Skin', 'Skin Tone', 'Human', 'Pale'],
    devTags: ['hidden_opensea'],
  },
  {
    id: 164,
    name: 'Sand',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Tone',
    searchableTags: ['Skin', 'Skin Tone', 'Human', 'Pale'],
    devTags: ['hidden_opensea'],
  },
  {
    id: 386,
    name: 'Senna',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Tone',
    searchableTags: ['Skin', 'Skin Tone', 'Human', 'Tan'],
    devTags: ['hidden_opensea'],
  },
  {
    id: 287,
    name: 'Umber',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Tone',
    searchableTags: ['Skin', 'Skin Tone', 'Human', 'Dark'],
    devTags: ['hidden_opensea'],
  },
  {
    id: 191,
    name: 'Vampire',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Tone',
    searchableTags: ['Skin', 'Skin Tone', 'Vampire', 'Halloween', 'Pale', 'New'],
    devTags: ['hidden_opensea'],
  },
  {
    id: 264,
    name: 'Warm Ivory',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Tone',
    searchableTags: ['Skin', 'Skin Tone', 'Human', 'Pale'],
    devTags: ['hidden_opensea'],
  },
  {
    id: 360,
    name: 'Wicked',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Tone',
    searchableTags: ['Skin', 'Skin Tone', 'Witch', 'Wicked', 'Purple', 'Halloween', 'New'],
    devTags: ['hidden_opensea'],
  },
  {
    id: 58,
    name: 'Zombie',
    stage: 'Final',
    category1: 'Body',
    category2: 'Skin',
    category3: 'Tone',
    searchableTags: ['Skin', 'Skin Tone', 'Zombie', 'Halloween', 'New'],
    devTags: ['hidden_opensea'],
  },
  {
    id: 182,
    name: 'Black Cargo Pants',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Pants',
    searchableTags: [],
    devTags: [],
    frontIndex: 9000,
    basicFrontFile: 'Black Cargo Pants.svg',
  },
  {
    id: 49,
    name: 'Blue Funky Pants',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Pants',
    searchableTags: [],
    devTags: [],
    frontIndex: 9000,
    basicFrontFile: 'Blue Funky Pants.svg',
  },
  {
    id: 246,
    name: 'Cargo Pants',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Pants',
    searchableTags: [],
    devTags: [],
    frontIndex: 9000,
    basicFrontFile: 'Cargo Pants.svg',
  },
  {
    id: 309,
    name: 'Dress Pants',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Pants',
    searchableTags: [],
    devTags: [],
    frontIndex: 9000,
    basicFrontFile: 'Dress Pants.svg',
  },
  {
    id: 214,
    name: 'Flower Pants',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Pants',
    searchableTags: [],
    devTags: [],
    frontIndex: 9000,
    basicFrontFile: 'Flower Pants.svg',
  },
  {
    id: 52,
    name: 'Grey Leggings',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Pants',
    searchableTags: [],
    devTags: [],
    frontIndex: 9000,
    basicFrontFile: 'Grey Leggings.svg',
  },
  {
    id: 99,
    name: 'High Waisted Pants',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Pants',
    searchableTags: [],
    devTags: [],
    frontIndex: 9000,
    basicFrontFile: 'High Waisted Pants.svg',
  },
  {
    id: 46,
    name: 'Joggers',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Pants',
    searchableTags: [],
    devTags: [],
    frontIndex: 10500,
    basicFrontFile: 'Joggers.svg',
  },
  {
    id: 113,
    name: 'Leather Pants',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Pants',
    searchableTags: [],
    devTags: [],
    basicFrontFile: 'Leather Pants.svg',
  },
  {
    id: 226,
    name: 'Navy Suit Pants',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Pants',
    searchableTags: ['New'],
    devTags: [],
    frontIndex: 9000,
    basicFrontFile: 'Navy Suit Pants.svg',
  },
  {
    id: 215,
    name: 'Ripped Jeans',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Pants',
    searchableTags: [],
    devTags: [],
    frontIndex: 9000,
    basicFrontFile: 'Ripped Jeans.svg',
  },
  {
    id: 22,
    name: 'Rolled Up Jeans',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Pants',
    searchableTags: [],
    devTags: [],
    frontIndex: 9000,
    basicFrontFile: 'Rolled Up Jeans.svg',
  },
  {
    id: 310,
    name: 'Skinny Black Jeans',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Pants',
    searchableTags: [],
    devTags: [],
    frontIndex: 10500,
    basicFrontFile: 'Skinny Black Jeans.svg',
  },
  {
    id: 319,
    name: 'Skinny Jeans',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Pants',
    searchableTags: ['Blue'],
    devTags: [],
    frontIndex: 10500,
    basicFrontFile: 'Skinny Jeans.svg',
  },
  {
    id: 80,
    name: 'Straight Jeans',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Pants',
    searchableTags: [],
    devTags: [],
    frontIndex: 9000,
    basicFrontFile: 'Straight Jeans.svg',
  },
  {
    id: 102,
    name: 'Sweatpants',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Pants',
    searchableTags: [],
    devTags: [],
    frontIndex: 9000,
    basicFrontFile: 'Sweatpants.svg',
  },
  {
    id: 196,
    name: 'Uniform Pants',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Pants',
    searchableTags: [],
    devTags: [],
    frontIndex: 9000,
    basicFrontFile: 'Uniform Pants.svg',
  },
  {
    id: 334,
    name: 'Wide Jeans',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Pants',
    searchableTags: [],
    devTags: [],
    frontIndex: 9000,
    basicFrontFile: 'Wide Jeans.svg',
  },
  {
    id: 37,
    name: 'Cargo Shorts',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Shorts',
    searchableTags: [],
    devTags: [],
    frontIndex: 9000,
    basicFrontFile: 'Cargo Shorts.svg',
  },
  {
    id: 307,
    name: 'Denim Shorts',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Shorts',
    searchableTags: [],
    devTags: [],
    frontIndex: 9000,
    basicFrontFile: 'Denim Shorts.svg',
  },
  {
    id: 229,
    name: 'Shorts',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Shorts',
    searchableTags: [],
    devTags: [],
    frontIndex: 9000,
    basicFrontFile: 'Shorts.svg',
  },
  {
    id: 13,
    name: 'Stubbies',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Shorts',
    searchableTags: [],
    devTags: [],
    frontIndex: 9000,
    basicFrontFile: 'Stubbies.svg',
  },
  {
    id: 336,
    name: 'Tan Shorts',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Shorts',
    searchableTags: [],
    devTags: [],
    frontIndex: 9000,
    basicFrontFile: 'Tan Shorts.svg',
  },
  {
    id: 123,
    name: 'Black Skirt',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Skirt',
    searchableTags: [],
    devTags: [],
    frontIndex: 9000,
    basicFrontFile: 'Black Skirt.svg',
  },
  {
    id: 82,
    name: 'Flared Maxi Skirt',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Skirt',
    searchableTags: [],
    devTags: [],
    frontIndex: 9000,
    basicFrontFile: 'Flared Maxi Skirt.svg',
  },
  {
    id: 193,
    name: 'Long Pleated Skirt',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Bottoms',
    category3: 'Skirt',
    searchableTags: [],
    devTags: [],
    frontIndex: 9000,
    basicFrontFile: 'Long Pleated Skirt.svg',
  },
  {
    id: 119,
    name: 'Forest Dress',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Dresses',
    searchableTags: [],
    devTags: [],
    frontIndex: 7000,
    basicFrontFile: 'Forest Dress.svg',
  },
  {
    id: 12,
    name: 'Frilled Mini Dress',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Dresses',
    searchableTags: [],
    devTags: [],
    frontIndex: 7000,
    basicFrontFile: 'Frilled Mini Dress.svg',
  },
  {
    id: 349,
    name: 'Hippie Tunic Dress',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Dresses',
    searchableTags: [],
    devTags: [],
    frontIndex: 7000,
    basicFrontFile: 'Hippie Tunic Dress.svg',
  },
  {
    id: 77,
    name: 'Layered Dress',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Dresses',
    searchableTags: [],
    devTags: [],
    frontIndex: 7000,
    basicFrontFile: 'Layered Dress.svg',
  },
  {
    id: 345,
    name: 'Little Black Dress',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Dresses',
    searchableTags: [],
    devTags: [],
    frontIndex: 7000,
    basicFrontFile: 'Little Black Dress.svg',
  },
  {
    id: 73,
    name: 'Mumu Dress',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Dresses',
    searchableTags: ['New'],
    devTags: [],
    frontIndex: 7000,
    basicFrontFile: 'Mumu Dress.svg',
  },
  {
    id: 64,
    name: 'Pink Midi Dress',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Dresses',
    searchableTags: [],
    devTags: [],
    frontIndex: 7000,
    basicFrontFile: 'Pink Midi Dress.svg',
  },
  {
    id: 25,
    name: 'Red Midi Dress',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Dresses',
    searchableTags: [],
    devTags: [],
    frontIndex: 7000,
    basicFrontFile: 'Red Midi Dress.svg',
  },
  {
    id: 28,
    name: 'Overalls',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Jumpsuits',
    searchableTags: [],
    devTags: [],
    frontIndex: 5000,
    backIndex: 19000,
    basicFrontFile: 'Overalls Front.svg',
  },
  {
    id: 60,
    name: 'Dracula Cape',
    stage: 'Art Updates',
    category1: 'Clothing',
    category2: 'Outerwear',
    category3: 'Cape',
    searchableTags: ['New', 'Halloween', 'Seasonal', 'Cape', 'Dracula', 'Black', 'Red'],
    devTags: [],
    frontIndex: 5000,
    backIndex: 19000,
    basicFrontFile: 'Dracula Cape Front.svg',
    basicBackFile: 'Dracula Cape Back.svg',
  },
  {
    id: 236,
    name: 'Red Riding Hood Cape',
    stage: 'Art Updates',
    category1: 'Clothing',
    category2: 'Outerwear',
    category3: 'Cape',
    searchableTags: ['New', 'Cape', 'Halloween', 'Seasonal', 'Outerwear', 'Red', 'Red Riding Hood'],
    devTags: [],
    frontIndex: 5000,
    backIndex: 19000,
    basicFrontFile: 'Red Riding Hood Cape Front.svg',
    basicBackFile: 'Red Riding Hood Cape Back.svg',
  },
  {
    id: 283,
    name: 'MrsMilkys Signature Yellow Cardigan',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Outerwear',
    category3: 'Cardigen',
    searchableTags: [],
    devTags: [],
    frontIndex: 5000,
    backIndex: 19000,
    basicFrontFile: 'MrsMilkys Signature Yellow Cardigan Front.svg',
    basicBackFile: 'MrsMilkys Signature Yellow Cardigan Back.svg',
  },
  {
    id: 253,
    name: 'Labcoat',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Outerwear',
    category3: 'Coat',
    searchableTags: [],
    devTags: [],
    frontIndex: 5000,
    backIndex: 19000,
    basicFrontFile: 'Labcoat Front.svg',
    basicBackFile: 'Labcoat Back.svg',
  },
  {
    id: 10,
    name: 'Winter Coat',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Outerwear',
    category3: 'Coat',
    searchableTags: [],
    devTags: [],
    frontIndex: 5000,
    backIndex: 19000,
    basicFrontFile: 'Winter Coat.svg',
  },
  {
    id: 317,
    name: 'Black Hoodie (AP)',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Outerwear',
    category3: 'Hoodie',
    searchableTags: [],
    devTags: [],
    frontIndex: 5000,
    basicFrontFile: 'Black Hoodie (AP) Front.svg',
  },
  {
    id: 104,
    name: 'Black Hoodie (WP)',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Outerwear',
    category3: 'Hoodie',
    searchableTags: [],
    devTags: [],
    frontIndex: 5000,
    basicFrontFile: 'Black Hoodie (WP) Front.svg',
  },
  {
    id: 7,
    name: 'Blue Hoodie (WP)',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Outerwear',
    category3: 'Hoodie',
    searchableTags: [],
    devTags: [],
    frontIndex: 5000,
    basicFrontFile: 'Blue Hoodie (WP) Front.svg',
  },
  {
    id: 199,
    name: 'Dino Hoodie',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Outerwear',
    category3: 'Hoodie',
    searchableTags: [],
    devTags: [],
    frontIndex: 5000,
    basicFrontFile: 'Dino Hoodie Front.svg',
    basicBackFile: 'Dino Hoodie Back.svg',
  },
  {
    id: 308,
    name: 'Exclusive HL Hoodie',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Outerwear',
    category3: 'Hoodie',
    searchableTags: [],
    devTags: [],
    frontIndex: 5000,
    basicFrontFile: 'Exclusive HL Hoodie Front.svg',
  },
  {
    id: 174,
    name: 'Exclusive HL Sweater',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Outerwear',
    category3: 'Hoodie',
    searchableTags: [],
    devTags: [],
    frontIndex: 5000,
    basicFrontFile: 'Exclusive HL Sweater Front.svg',
  },
  {
    id: 4,
    name: 'I AM Hoodie',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Outerwear',
    category3: 'Hoodie',
    searchableTags: [],
    devTags: [],
    frontIndex: 5000,
    basicFrontFile: 'I AM Hoodie Front.svg',
  },
  {
    id: 364,
    name: 'Tan Hoodie',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Outerwear',
    category3: 'Hoodie',
    searchableTags: [],
    devTags: [],
    frontIndex: 5000,
    backIndex: 19000,
    basicFrontFile: 'Tan Hoodie Front.svg',
  },
  {
    id: 33,
    name: 'Teal Hoodie',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Outerwear',
    category3: 'Hoodie',
    searchableTags: [],
    devTags: [],
    frontIndex: 5000,
    backIndex: 19000,
    basicFrontFile: 'Teal Hoodie Front.svg',
  },
  {
    id: 29,
    name: 'Layered Jackets',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Outerwear',
    category3: 'Jacket',
    searchableTags: [],
    devTags: [],
    frontIndex: 5000,
    basicFrontFile: 'Layered Jackets Front.svg',
  },
  {
    id: 266,
    name: 'Long Jacket',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Outerwear',
    category3: 'Jacket',
    searchableTags: [],
    devTags: [],
    frontIndex: 5000,
    backIndex: 19000,
    basicFrontFile: 'Long Jacket Front.svg',
    basicBackFile: 'Long Jacket Back.svg',
  },
  {
    id: 381,
    name: 'Navy Suit Jacket',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Outerwear',
    category3: 'Jacket',
    searchableTags: ['New'],
    devTags: [],
    frontIndex: 5000,
    basicFrontFile: 'Navy Suit Jacket Front.svg',
  },
  {
    id: 395,
    name: 'Long Sleeve School Uniform',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'School Uniform',
    category3: 'Tops',
    searchableTags: [],
    devTags: [],
    frontIndex: 8000,
    basicFrontFile: 'CBS Long Sleeve.svg',
  },
  {
    id: 396,
    name: 'Winter Blouse School Uniform',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'School Uniform',
    category3: 'Tops',
    searchableTags: [],
    devTags: [],
    frontIndex: 8000,
    basicFrontFile: 'CBS White Collar.svg',
    chibiBasicFrontFile: 'CBS White Collar Chibi.svg',
  },
  {
    id: 211,
    name: 'Exclusive GG Sheet',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Set',
    searchableTags: [
      'New',
      'Halloween',
      'Costume',
      'Ghost',
      'White',
      'Sheet',
      'Seasonal',
      'Hide Hair',
    ],
    devTags: ['Hide Hair'],
    frontIndex: 5000,
    backIndex: 19000,
    basicFrontFile: 'Exclusive GG Sheet Front.svg',
  },
  {
    id: 162,
    name: 'Seasonal Elf Outfit',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Set',
    searchableTags: [],
    devTags: [],
    frontIndex: 7000,
    basicFrontFile: 'Seasonal Elf Outfit.svg',
  },
  {
    id: 294,
    name: 'Seasonal Santa Outfit',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Set',
    searchableTags: [],
    devTags: [],
    frontIndex: 7000,
    basicFrontFile: 'Seasonal Santa Outfit.svg',
  },
  {
    id: 315,
    name: 'Navy Formal Suit',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Set',
    category3: 'Suit',
    searchableTags: ['New'],
    devTags: [],
    frontIndex: 7000,
    basicFrontFile: 'Navy Formal Suit.svg',
  },
  {
    id: 232,
    name: 'Chefs Uniform',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Set',
    category3: 'Uniform',
    searchableTags: [],
    devTags: [],
    frontIndex: 7000,
    basicFrontFile: 'Chefs Uniform.svg',
  },
  {
    id: 84,
    name: 'Scrubs',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Set',
    category3: 'Uniform',
    searchableTags: [],
    devTags: [],
    frontIndex: 7000,
    basicFrontFile: 'Scrubs.svg',
  },
  {
    id: 343,
    name: 'Spacesuit',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Set',
    category3: 'Uniform',
    searchableTags: [],
    devTags: [],
    frontIndex: 5500,
    backIndex: 19000,
    basicFrontFile: 'Spacesuit Front.svg',
  },
  {
    id: 94,
    name: 'Black High Tops',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Shoes',
    searchableTags: [],
    devTags: [],
    frontIndex: 10000,
    basicFrontFile: 'Black High Tops.svg',
  },
  {
    id: 311,
    name: 'Checkered Shoes',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Shoes',
    searchableTags: [],
    devTags: [],
    frontIndex: 10000,
    basicFrontFile: 'Checkered Shoes.svg',
  },
  {
    id: 357,
    name: 'Crocs',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Shoes',
    searchableTags: [],
    devTags: [],
    frontIndex: 10000,
    basicFrontFile: 'Crocs.svg',
  },
  {
    id: 92,
    name: 'Green High Tops',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Shoes',
    searchableTags: [],
    devTags: [],
    frontIndex: 10000,
    basicFrontFile: 'Green High Tops.svg',
  },
  {
    id: 1,
    name: 'Gumboots',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Shoes',
    searchableTags: [],
    devTags: [],
    frontIndex: 6000,
    basicFrontFile: 'Gumboots.svg',
  },
  {
    id: 32,
    name: 'High Heels',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Shoes',
    searchableTags: [],
    devTags: [],
    frontIndex: 10000,
    basicFrontFile: 'High Heels.svg',
  },
  {
    id: 86,
    name: 'Leopard Print Shoes',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Shoes',
    searchableTags: [],
    devTags: [],
    frontIndex: 10000,
    basicFrontFile: 'Leopard Print Shoes.svg',
  },
  {
    id: 252,
    name: 'White High Tops',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Shoes',
    searchableTags: [],
    devTags: [],
    frontIndex: 10000,
    basicFrontFile: 'White High Tops.svg',
  },
  {
    id: 139,
    name: 'Black Collar',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Tops',
    category3: 'Dress Shirt',
    searchableTags: [],
    devTags: [],
    frontIndex: 8000,
    basicFrontFile: 'Black Collar.svg',
  },
  {
    id: 14,
    name: 'Blue Collar',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Tops',
    category3: 'Dress Shirt',
    searchableTags: [],
    devTags: [],
    frontIndex: 8000,
    basicFrontFile: 'Blue Collar.svg',
  },
  {
    id: 183,
    name: 'Kurta',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Tops',
    category3: 'Dress Shirt',
    searchableTags: [],
    devTags: [],
    frontIndex: 8000,
    basicFrontFile: 'Kurta.svg',
  },
  {
    id: 380,
    name: 'Shirt with Suspenders',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Tops',
    category3: 'Dress Shirt',
    searchableTags: [],
    devTags: [],
    frontIndex: 8000,
    basicFrontFile: 'Shirt with Suspenders.svg',
  },
  {
    id: 70,
    name: 'White Collar',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Tops',
    category3: 'Dress Shirt',
    searchableTags: [],
    devTags: [],
    frontIndex: 8000,
    basicFrontFile: 'White Collar.svg',
  },
  {
    id: 289,
    name: 'Layered Shirts',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Tops',
    category3: 'Long Sleeve',
    searchableTags: [],
    devTags: [],
    frontIndex: 8000,
    basicFrontFile: 'Layered Shirts.svg',
  },
  {
    id: 88,
    name: 'Long Sleeve',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Tops',
    category3: 'Long Sleeve',
    searchableTags: [],
    devTags: [],
    frontIndex: 8000,
    basicFrontFile: 'Long Sleeve.svg',
    chibiBasicFrontFile: 'CBS Long Sleeve.svg',
  },
  {
    id: 303,
    name: 'Black Tee',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Tops',
    category3: 'Shirt',
    searchableTags: [],
    devTags: [],
    frontIndex: 8000,
    basicFrontFile: 'Black Tee.svg',
  },
  {
    id: 224,
    name: 'Exclusive CC T-Shirt',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Tops',
    category3: 'Shirt',
    searchableTags: [],
    devTags: [],
    frontIndex: 8000,
    basicFrontFile: 'Exclusive CC T-Shirt.svg',
  },
  {
    id: 329,
    name: 'Grey T-Shirt',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Tops',
    category3: 'Shirt',
    searchableTags: ['Orange', 'Maroon', 'Grey'],
    devTags: [],
    frontIndex: 8000,
    basicFrontFile: 'Grey T-Shirt.svg',
  },
  {
    id: 302,
    name: 'Hippie Tunic',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Tops',
    category3: 'Shirt',
    searchableTags: [],
    devTags: [],
    frontIndex: 8000,
    basicFrontFile: 'Hippie Tunic.svg',
  },
  {
    id: 254,
    name: 'Muscle T-Shirt',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Tops',
    category3: 'Shirt',
    searchableTags: [],
    devTags: [],
    frontIndex: 8000,
    basicFrontFile: 'Muscle T-Shirt.svg',
  },
  {
    id: 361,
    name: 'Orange T-Shirt',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Tops',
    category3: 'Shirt',
    searchableTags: [],
    devTags: [],
    frontIndex: 8000,
    basicFrontFile: 'Orange T-Shirt.svg',
  },
  {
    id: 272,
    name: 'Peep T-Shirt',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Tops',
    category3: 'Shirt',
    searchableTags: [],
    devTags: [],
    frontIndex: 8000,
    basicFrontFile: 'Peep T-Shirt.svg',
  },
  {
    id: 351,
    name: 'Pocket T-Shirt',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Tops',
    category3: 'Shirt',
    searchableTags: [],
    devTags: [],
    frontIndex: 8000,
    basicFrontFile: 'Pocket T-Shirt.svg',
  },
  {
    id: 269,
    name: 'Rugged T-Shirt',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Tops',
    category3: 'Shirt',
    searchableTags: [],
    devTags: [],
    frontIndex: 8000,
    basicFrontFile: 'Rugged T-Shirt.svg',
  },
  {
    id: 338,
    name: 'Black Tank Top',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Tops',
    category3: 'Tank Top',
    searchableTags: [],
    devTags: [],
    frontIndex: 8000,
    basicFrontFile: 'Black Tank Top.svg',
  },
  {
    id: 359,
    name: 'Purple Tank',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Tops',
    category3: 'Tank Top',
    searchableTags: [],
    devTags: [],
    frontIndex: 8000,
    basicFrontFile: 'Purple Tank.svg',
  },
  {
    id: 258,
    name: 'Exclusive GCWC Vest',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Tops',
    category3: 'Vest',
    searchableTags: [],
    devTags: [],
    frontIndex: 5000,
    basicFrontFile: 'Exclusive GCWC Vest Front.svg',
  },
  {
    id: 59,
    name: 'High Viz Vest',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Tops',
    category3: 'Vest',
    searchableTags: [],
    devTags: [],
    frontIndex: 5000,
    backIndex: 19000,
    basicFrontFile: 'High Viz Vest Front.svg',
    basicBackFile: 'High Viz Vest Back.svg',
  },
  {
    id: 125,
    name: 'Tassled Vest',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Tops',
    category3: 'Vest',
    searchableTags: [],
    devTags: [],
    frontIndex: 5000,
    backIndex: 19000,
    basicFrontFile: 'Tassled Vest Front.svg',
  },
  {
    id: 16,
    name: 'Uniform Vest',
    stage: 'Final',
    category1: 'Clothing',
    category2: 'Tops',
    category3: 'Vest',
    searchableTags: [],
    devTags: [],
    frontIndex: 5000,
    backIndex: 19000,
    basicFrontFile: 'Uniform Vest Front.svg',
  },
  {
    id: 118,
    name: 'Beach',
    stage: 'Bug',
    category1: 'Location',
    category2: 'District',
    searchableTags: ['Beach', 'District', 'Sand', 'Ocean', 'Location', 'VeronicaRadd'],
    devTags: [],
    frontIndex: 21000,
    basicFrontFile: 'Beach.svg',
  },
  {
    id: 149,
    name: 'City',
    stage: 'Final',
    category1: 'Location',
    category2: 'District',
    searchableTags: ['City', 'District', 'Buildings', 'Location', 'VeronicaRadd'],
    devTags: [],
    frontIndex: 21000,
    basicFrontFile: 'City.svg',
  },
  {
    id: 251,
    name: 'Desert',
    stage: 'Final',
    category1: 'Location',
    category2: 'District',
    searchableTags: ['Desert', 'District', 'Sand', 'Cactus', 'VeronicaRadd', 'Location'],
    devTags: [],
    frontIndex: 21000,
    basicFrontFile: 'Desert.svg',
  },
  {
    id: 202,
    name: 'Forest',
    stage: 'Final',
    category1: 'Location',
    category2: 'District',
    searchableTags: ['Forest', 'District', 'Trees', 'Green', 'VeronicaRadd', 'Location'],
    devTags: [],
    frontIndex: 21000,
    basicFrontFile: 'Forest.svg',
  },
  {
    id: 239,
    name: 'Graveyard',
    stage: 'Final',
    category1: 'Location',
    category2: 'District',
    searchableTags: ['New', 'Halloween', 'Graveyard', 'Spooky', 'District', 'Location'],
    devTags: [],
    frontIndex: 21000,
    basicFrontFile: 'Graveyard.svg',
  },
  {
    id: 281,
    name: 'Mountains',
    stage: 'Final',
    category1: 'Location',
    category2: 'District',
    searchableTags: ['Mountains', 'District', 'VeronicaRadd', 'Location'],
    devTags: [],
    frontIndex: 21000,
    basicFrontFile: 'Mountains.svg',
  },
  {
    id: 18,
    name: 'Spooky Tree',
    stage: 'Final',
    category1: 'Location',
    category2: 'District',
    searchableTags: ['New', 'Halloween', 'Spooky', 'Spooky Tree', 'Location', 'District'],
    devTags: [],
    frontIndex: 21000,
    basicFrontFile: 'Spooky Tree.svg',
  },
  {
    id: 377,
    name: 'Suburb',
    stage: 'Final',
    category1: 'Location',
    category2: 'District',
    searchableTags: ['Suburb', 'District', 'VeronicaRadd', 'Houses', 'Location'],
    devTags: [],
    frontIndex: 21000,
    basicFrontFile: 'Suburb.svg',
  },
  {
    id: 100,
    name: 'Crescent Moonlight',
    stage: 'Final',
    category1: 'Location',
    category2: 'Time',
    searchableTags: ['New', 'Halloween', 'Time', 'Crescent Moon', 'Full Moon', 'Black', 'Moon'],
    devTags: [],
    frontIndex: 22000,
    basicFrontFile: 'Crescent Moonlight.svg',
  },
  {
    id: 91,
    name: 'Day',
    stage: 'Final',
    category1: 'Location',
    category2: 'Time',
    searchableTags: ['Time', 'Green', 'Yellow', 'VeronicaRadd', 'Day'],
    devTags: [],
    frontIndex: 22000,
    basicFrontFile: 'Day.svg',
  },
  {
    id: 21,
    name: 'Night',
    stage: 'Final',
    category1: 'Location',
    category2: 'Time',
    searchableTags: ['Night', 'Time', 'Blue', 'VeronicaRadd', 'New'],
    devTags: [],
    frontIndex: 22000,
    basicFrontFile: 'Night.svg',
  },
  {
    id: 371,
    name: 'Purple Haze',
    stage: 'Final',
    category1: 'Location',
    category2: 'Time',
    searchableTags: ['New', 'Halloween', 'Time', 'Shooting Stars', 'Comets', 'Purple'],
    devTags: [],
    frontIndex: 22000,
    basicFrontFile: 'Purple Haze.svg',
  },
  {
    id: 293,
    name: 'Shepards Warning',
    stage: 'Final',
    category1: 'Location',
    category2: 'Time',
    searchableTags: ['New', 'Halloween', 'Time', 'Red', 'Blood', 'Blood Moon', 'Full Moon', 'Moon'],
    devTags: [],
    frontIndex: 22000,
    basicFrontFile: 'Shepards Warning.svg',
  },
  {
    id: 178,
    name: 'Sunset',
    stage: 'Bug',
    category1: 'Location',
    category2: 'Time',
    searchableTags: ['Sunset', 'Time', 'Orange', 'VeronicaRadd'],
    devTags: [],
    frontIndex: 22000,
    basicFrontFile: 'Sunset.svg',
  },
  {
    id: 83,
    name: 'Witching Hour',
    stage: 'Final',
    category1: 'Location',
    category2: 'Time',
    searchableTags: ['New', 'Halloween', 'Time', 'Full Moon', 'Blue', 'Yellow', 'Moon'],
    devTags: [],
    frontIndex: 22000,
    basicFrontFile: 'Witching Hour.svg',
  },
  {
    id: 387,
    name: 'Chibi Basic',
    stage: 'In Quality Control',
    category1: 'Pose',
    category2: 'Chibi Poses',
    searchableTags: [],
    devTags: [],
    frontIndex: 11000,
    chibiBasicFrontFile: 'Chibi Basic.svg',
  },
  {
    id: 95,
    name: 'Arm Behind Back',
    stage: 'Art Updates',
    category1: 'Pose',
    category2: 'Stick Figure Poses',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 11000,
    armBehindBackFrontFile: 'Arm Behind Back.svg',
  },
  {
    id: 295,
    name: 'Basic',
    stage: 'Final',
    category1: 'Pose',
    category2: 'Stick Figure Poses',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 11000,
    basicFrontFile: 'Basic.svg',
  },
  {
    id: 245,
    name: 'Hip',
    stage: 'Art Updates',
    category1: 'Pose',
    category2: 'Stick Figure Poses',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 11000,
    hipFrontFile: 'Hip.svg',
  },
  {
    id: 379,
    name: 'Holding',
    stage: 'In Quality Control',
    category1: 'Pose',
    category2: 'Stick Figure Poses',
    searchableTags: ['Hold'],
    devTags: ['hidden_opensea'],
    frontIndex: 5500,
    backIndex: 11000,
    holdingFrontFile: 'Holding Top.svg',
    holdingBackFile: 'Holding.svg',
  },
  {
    id: 327,
    name: 'Peace',
    stage: 'Art Updates',
    category1: 'Pose',
    category2: 'Stick Figure Poses',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 11000,
    peaceFrontFile: 'Peace.svg',
  },
  {
    id: 44,
    name: 'Wave',
    stage: 'Art Updates',
    category1: 'Pose',
    category2: 'Stick Figure Poses',
    searchableTags: [],
    devTags: ['hidden_opensea'],
    frontIndex: 11000,
    waveFrontFile: 'Wave.svg',
  },
]

export const getTraitsData = (all?: boolean) =>
  traitsData.filter(t => (all ? true : t.stage === 'Final'))
